import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AppService } from 'src/app/_services/app.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {

  footerProperties: FooterParameters;


  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, public service: AppService) { }

  ngOnInit() {
    this.InitializeFooter();
    this.http.get<FooterParameters>(this.baseUrl + 'api/common/getFooterDetails').subscribe(result => {
      this.footerProperties = result;
    }, error => {
      console.error(error);
    });
    // Initialize culture for the login screen (No header)
    this.service.checkCultureCookie();
  }

  /** Initializes the footer parameters */
  InitializeFooter() {
    this.footerProperties = {
      currentYear: '0000',
      ipAddress: '0.0.0.0',
      productVersion: '0',
      contactDetails: ''
    };
  }
}

/** Interface to access the footer parameters */
interface FooterParameters {
  currentYear: string;
  ipAddress: string;
  productVersion: string;
  contactDetails: string;
}
